import * as React from "react";
const SvgFiBrandsYahoo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-yahoo_svg__a)">
      <path
        fill="#151A2D"
        d="m10.349 6.302-2.81 7.097-2.777-7.097H0l5.246 12.35-1.912 4.452h4.668l6.985-16.802zm5.225 6.732a2.886 2.886 0 1 0 0 5.772 2.886 2.886 0 0 0 0-5.772M18.824.896l-4.61 11.078h5.195L24 .896z"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-yahoo_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsYahoo;
